import React, { useEffect, useState } from 'react'
import '../../scss/pages/MyCertificates/myCertificates.scss';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import Training from './Training/Training';
import { useDispatch } from 'react-redux';
import { getLocalStoreString } from '../../utils/Helper';
import { GET_MY_CERTIFICATE_DATA, GET_SPOT_REWARDS_DATA } from '../../sagas/type';
import SpotRewards from './SpotRewards/SpotRewards';
import { useLocation } from 'react-router';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        // style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`
    };
}
function MyCertificate() {
    const dispatch = useDispatch()
    const [value, setValue] = useState(0);
    const location = useLocation();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const getMyCertificateData = () => {
        dispatch({
            type: GET_MY_CERTIFICATE_DATA,
        })
    }
    const getMySPotRewards = () => {
        dispatch({
            type: GET_SPOT_REWARDS_DATA,
        })
    }
    window.addEventListener('employeeDetailsFetch', () => {
        getMyCertificateData();
        getMySPotRewards();
    })
    useEffect(() => {
        getMyCertificateData();
        getMySPotRewards()
    }, [])

    useEffect(() => {
        if (location?.state?.pageIndex) {
            setValue(location?.state?.pageIndex)
        }
    }, [location?.state?.pageIndex])
    return (
        <div className='My-certificate-Container' >
            <div className='My-certificate-Container_header'>
                <div className='My-certificate-Container_header_head-height'>
                    <span className='My-certificate-Container_header_head-height_content'>My Certificate</span>
                </div>
            </div>
            <div className='My-certificate-Container_tabs-Container'>
                <Tabs value={value} onChange={handleChange}>
                    <Tab label="Training" {...a11yProps(0)} style={value == 0 ? { color: 'black', padding: '1px 10px', background: '#FFFFFF', borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: '10px', fontFamily: 'Noto Sans' } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", padding: '1px 10px', background: 'rgba(255, 255, 255, 0.1)', fontWeight: 500, fontSize: '10px', borderRadius: '40px', fontFamily: 'Noto Sans', }} />
                    <Tab label="Spot Rewards" {...a11yProps(1)} style={value == 1 ? { color: 'black', padding: '1px 10px', background: '#FFFFFF', borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: '10px', fontFamily: 'Noto Sans' } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", padding: '1px 10px', background: 'rgba(255, 255, 255, 0.1)', fontWeight: 500, fontSize: '10px', borderRadius: '40px', fontFamily: 'Noto Sans', }} />
                </Tabs>
            </div>
            <TabPanel value={value} index={0}>
                <Training setValue={setValue} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <SpotRewards setValue={setValue} />
            </TabPanel>
        </div >
    )
}

export default MyCertificate;